import React from 'react'
import ContentLocalizationsLayout from './ContentLocalizationsLayout'

const ContentLocalization = () => {
  return <ContentLocalizationsLayout />
}

export default ContentLocalization
